import React from "react";
import { useSelector } from "react-redux";

import { Button } from "@onegovbugs/onegov-react-components";
import classes from "./LogoutConfirmation.module.scss";
import { saveApplication } from "../../../redux/actions";
import { useDispatch } from "react-redux";
import Cancel from "@material-ui/icons/Cancel";
import { IMPORTEXPORT_FORM, FLORAFAUNA_FORM } from "../../../constants";
import {
  getStepNumberWithFloraFaunaUrl,
  getStepNumberIndWithImportExportUrl,
} from "../../../utils/NavigationHelper";

const LogoutConfirmation = (props) => {
  const { onLogoutClick, onClickClose } = props;
  const dispatch = useDispatch();
  const form = useSelector((state) => state.form);

  return (
    <div className={classes.mainCont}>
      <div className={classes.popupOuter}>
        <div className={classes.popupInner}>
          <div className={classes.popupFilter}>
            
            <h3>
              Your session has expired. <br />
              <br />
              Please login again.
            </h3>

            <div className={"row " + classes.topMargin128}>
              <div className={"col-12"}>
                <Button
                  onClick={() => {
                    onLogoutClick();
                  }}
                >
                 Login
                </Button>
                {/* <Button
                  secondary
                  onClick={() => {
                    onLogoutClick();
                  }}
                >
                  Logout
                </Button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmation;
